<template>
  <div
    ref="uploadVideo"
    :class="'upload-video-' + listType"
    class="rt-upload-video"
  >
    <div
      v-for="(item, i) in videoList"
      ref="item"
      :key="i"
      :style="{ width: videoWidth }"
      class="file-item"
    >
      <div class="box">
        <div class="scale">
          <div
            class="video"
            @click="videoClick(item.url)"
          >
            <div
              v-if="!item.url"
              class="uploading"
            >
              <img
                src="../../assets/imgs/file_icon.png"
                alt
              />
              <div class="uploading-text">
                <span v-if="videoFlag == true && item.videoUploadPercent > 0">{{
                  $tx('正在上传...', 'xpc.uploadfile.uploading')
                }}</span>
                <span v-else-if="item.videoUploadPercent == 100 && !item.name">{{
                  $tx('上传错误', 'xpc.uploadfile.uploadError')
                }}</span>
              </div>
            </div>
            <div v-else>
              <video :src="item.url" />
              <div class="layout">
                <rt-icon
                  name="rt-base-angle_right_circle"
                  size="35"
                  color="#fff"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="detail">
          <div class="detail-name">
            <rt-icon
              :color="SCSS_VARIABLES.COLOR_SUCCESS"
              name="rt-base-file-video-fill"
              size="21"
            />
            <p class="name">
              {{ item.name }}
            </p>
          </div>
          <el-progress
            v-if="videoFlag == true && item.videoUploadPercent > 0"
            :percentage="item.videoUploadPercent"
            :show-text="false"
            style="margin-top:7px;"
          />
          <div
            :class="{
              paddingTop: videoFlag == true && item.videoUploadPercent > 0
            }"
            class="progress-operation"
          >
            <p
              v-if="videoFlag == true && item.videoUploadPercent > 0"
              class="progress"
            >
              {{
                $tx(`已上传${item.videoUploadPercent}%`, 'xpc.uploadfile.uploadPercent', {
                  count: item.videoUploadPercent
                })
              }}
            </p>
            <p
              v-else-if="item.videoUploadPercent == 100 && !item.name"
              class="progress"
            >
              <rt-icon
                :color="SCSS_VARIABLES.COLOR_DANGER"
                name="rt-base-close_line"
                size="14"
              />
              <span>{{ $tx('上传错误', 'xpc.uploadfile.uploadError') }}</span>
              <rt-icon
                :color="SCSS_VARIABLES.NEUTRAL_COLOR_SECONDARY"
                name="rt-base-wrong-circle"
                size="14"
              />
            </p>
            <div class="btn">
              <rt-button
                text
                type="plain"
                @click="reUpload(i)"
              >
                {{
                  $tx('重新上传', 'xpc.uploadfile.reUpload')
                }}
              </rt-button>
              <rt-popconfirm
                :title="$tx('确定需要删除这条内容吗？', 'xpc.uploadfile.confirmdelete')"
                @onConfirm="onConfirm(item.name, i)"
              >
                <rt-button
                  slot="reference"
                  text
                  type="plain"
                >
                  {{ $tx('删除', 'xpc.uploadfile.delete') }}
                </rt-button>
              </rt-popconfirm>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-upload
      ref="upload"
      :show-file-list="false"
      :limit="limit"
      :multiple="multiple"
      :on-success="handleVideoSuccess"
      :before-upload="beforeUploadVideo"
      :http-request="uploadFile"
      :file-list="fileList"
      :style="computedHeight"
      :list-type="listType"
      action
      class="avatar-uploader"
    >
      <div class="avator-uploader-main">
        <rt-icon
          name="rt-base-plus"
          size="50"
          class="avatar-uploader-icon"
        />
        <p class="avatar-uploader-word">
          {{ $tx('请将需要上传的文件添加到此处', 'xpc.uploadfile.pleaseAddFileHint') }}
        </p>
      </div>
    </el-upload>
    <el-dialog :visible.sync="videoVisible">
      <video
        :src="previewUrl"
        controls="controls"
      />
    </el-dialog>
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon';
import RtButton from '../button/rtButton';
import RtPopconfirm from '../popconfirm/rtPopconfirm';

// import ossClient from '../upload/aliyun.oss.client';

export default {
  name: 'RtUploadVideo',
  components: {
    RtIcon,
    RtButton,
    RtPopconfirm
  },
  props: {
    value: {
      type: Array,
      default: () => []
    },
    uploadConf: {
      type: Object,
      required: true,
      default: () => ({})
    },
    limit: {
      type: Number,
      default: 10
    },
    multiple: {
      type: Boolean,
      default: false
    },
    listType: {
      type: String,
      default: 'common'
    }
  },
  data () {
    return {
      videoFlag: false,
      // 是否显示进度条
      videoUploadPercent: '',
      // 进度条的进度，
      isShowUploadVideo: false,
      // 显示上传按钮
      videoVisible: false,
      previewUrl: '',
      fileList: [],
      videoList: JSON.parse(JSON.stringify(this.value)) || [],
      index: -1,
      computedHeight: {},
      videoWidth: ''
    };
  },
  mounted () {
    this.$nextTick(() => {
      this.videoWidth = this.$refs.uploadVideo.clientWidth / 4;
      this.computedHeight = {
        height: this.$refs.uploadVideo.videoWidth / 8 + 88,
        width: this.videoWidth - 8
      };
    });
  },
  methods: {
    // 上传前回调
    beforeUploadVideo (file) {
      var fileSize = file.size / 1024 / 1024 < 5000;
      if (
        ['video/mp4', 'video/ogg', 'video/flv', 'video/avi', 'video/wmv', 'video/rmvb', 'video/mov'].indexOf(
          file.type
        ) === -1
      ) {
        this.$message.error(this.$tx('请上传正确的视频格式', 'xpc.uploadfile.pleaseAddCorrectVideoFormat'));
        return false;
      }
      if (!fileSize) {
        this.$message.error(this.$tx('视频大小不能超过5000MB', 'xpc.uploadfile.videoSizeCannotExceed5000'));
        return false;
      }
      this.isShowUploadVideo = false;
    },
    // 上传成功回调
    handleVideoSuccess (res) {
      this.isShowUploadVideo = true;
      this.index = -1;
    },
    uploadFile (file) {
      // let obj = {
      //   videoUploadPercent: 0,
      //   url: '',
      //   name: ''
      // };
      // if (this.index >= 0) {
      //   this.videoList.splice(this.index, 1, obj);
      // } else {
      //   this.videoList.push(obj);
      // }
      // const that = this;
      // let fileName = file.file.name;
      // ossClient(this.uploadConf)
      //   // .put(fileName, file.file)
      //   .multipartUpload(fileName, file.file, {
      //     progress: function(p) {
      //       //p进度条的值
      //       that.videoFlag = true;
      //       obj.videoUploadPercent = Math.floor(p * 100);
      //     }
      //   })
      //   .then(({ res, url, name }) => {
      //     if (res && res.status == 200) {
      //       console.log(`阿里云OSS上传图片成功回调`, res, url, name);
      //       let response = `http://${this.uploadConf.bucket}.${this.uploadConf.region}.aliyuncs.com/${fileName}`;
      //       obj.url = response;
      //       obj.name = name;
      //       this.handleVideoSuccess(obj);
      //     }
      //   })
      //   .catch(err => {
      //     console.log(`阿里云OSS上传图片失败回调`, err);
      //   });
    },
    // 重新上传
    reUpload (index) {
      this.index = index;
      this.$refs.upload.$refs['upload-inner'].handleClick();
    },
    onConfirm (name, index) {
      this.del(name, index);
    },
    del (name, index) {
      // ossClient(this.uploadConf)
      //   .delete(name)
      //   .then(res => {
      //     this.videoList.splice(index, 1);
      //   })
      //   .catch(err => {
      //     console.log('删除失败', err);
      //   });
    },
    // 视频预览
    videoClick (url) {
      this.videoVisible = true;
      this.previewUrl = url;
    },
    getVideoList () {
      return this.videoList;
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtUploadVideo.vue?e6393e40